module.exports = __webpack_public_path__ + "static/img/s4en.48f56d6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/theme/light/article/samSet/s4en.png
// module id = XMxz
// module chunks = 0